import {InstutionRole} from "../instution-role/instution-role.model";
import {Designation} from "../designation/designation.model";

export interface InstutionUser {
  id: string;
  profile?: ProfileDto;
  role?:InstutionRole;
  userDesignation?: Designation
  userType: 'NORMAL_STAFF' | 'CONTACT_PERSON'
}

export interface inputInstutionUsers {
  institutionUniqueId?: string;
  profilePhone?: string;
  profilePhoto?: string;
  profileTitle?: string;
  profileType?: ProfileType;
  profileUniqueId?: string;
  roleUniqueId?: string;
  userEmail?: string;
  userFirstName?: string;
  userLastName?: string;
}

export enum ProfileType {
  INST = 'INST',
  POPSM = 'POPSM',
  CIT = 'CIT',
  COMPANY = 'COMPANY',
  Executive= 'Executive',
}

export interface filteringInstutionUsers {
  profileType?: ProfileType;
  institutionUniqueId?: string;
}

export interface ProfileDto {
  id?: string;
  institutionUniqueId?: string;
  profilePhone?: string;
  profilePhoto?: string;
  profileTitle?: string;
  profileType?: ProfileType;
  profileUniqueId?: string;
  roleUniqueId?: string;
  userEmail?: string;
  userFirstName?: string;
  userLastName?: string;
  profileIsDeactivated?: boolean
}
